import { render, staticRenderFns } from "./MultiEditorCard.vue?vue&type=template&id=3c3519e0&scoped=true"
import script from "./MultiEditorCard.vue?vue&type=script&lang=js"
export * from "./MultiEditorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3519e0",
  null
  
)

export default component.exports